export default __webpack_public_path__ + "static/media/unmarried.64d988a8.png";